import React from 'react';

import { Badge } from '@lt/components';
import CurrencyFormat from '../../../../../../components/CurrencyFormat';

import type { Props } from './types';

const ExtraPrice = ({ price = 0, className = '' }: Props) => (
  <Badge className={className}>
    <CurrencyFormat value={price} prefix="+ " />
  </Badge>
);

export default ExtraPrice;
